import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { InstitutionMailTemplate, MailTemplateType } from '../entities/mail-templates.js';
import { notifyAbmeldung } from './abmeldung.js';

defineMailTemplate(MailTemplateType.ABMELDUNG_DURCH_EINRICHTUNG, {
  getMailData: arg1 => ({ data: {}, attachments: {}, scope: 'default' }),
  defaultTemplate: {
    subject: 'Abmeldung von Veranstaltung durch Veranstalter',
    content: `
          <p>Hallo {{title}} {{firstname}} {{lastname}},</p>
          <p>wir haben Sie soeben von folgender Veranstaltung abgemeldet:</p>
          <p>{{changed-registrations}}</p>
          <p>Die Abmeldung bezieht sich nur auf die aufgef&uuml;hrte Veranstaltung. Falls uns ein Fehler unterlaufen sein sollte, bitten wir Sie, sich mit uns <a href="mailto:contact@anmeldung.uni-frankfurt.de">per Mail </a>in Verbindung zu setzen.</p>
          <p>Eine Auflistung Ihrer Veranstaltungsanmeldungen f&uuml;r das aktuelle Semester finden Sie unter folgendem Link: {{login-link}}</p>
          <p>Wir freuen uns, wenn wir Sie in Zukunft in einer unserer Veranstaltungen begr&uuml;&szlig;en d&uuml;rfen und empfehlen Ihnen hierf&uuml;r unser Vortrags- und Workshop-Programm auf <a href="Wir freuen uns, wenn wir Sie in Zukunft in einer unserer Veranstaltungen begr&uuml;&szlig;en d&uuml;rfen und empfehlen Ihnen hierf&uuml;r unser Vortrags- und Workshop-Programm auf anmeldung.uni-frankfurt.de.">anmeldung.uni-frankfurt.de.</a></p>
          <p>Viele Gr&uuml;&szlig;e</p>
          <p>---------------------------------------------------------------------</p>
          <p>Hello {{title}} {{firstname}} {{lastname}},</p>
          <p>You have been deregisterd from the following event:</p>
          <p>{{changed-registrations}}</p>
          <p>The cancellation refers only to the listed event. If we have made a mistake, please contact us by e-mail.</p>
          <p>You can finde a list of your event registrations for the current semester under the following link: {{login-link}}</p>
          <p>We look forward to welcoming you to one of our events in the future and recommend our lecture and workshop program at anmeldung.uni-frankfurt.de for this purpose</p>
          <p>Best regards</p>
        `,
    footer: '',
  },
  variables: InstitutionMailTemplate.getAvailableVariables(MailTemplateType.ABMELDUNG_DURCH_EINRICHTUNG),
  attachments: [],
  displayName: 'Abmeldung durch Einrichtung',
  editorHint: () => InstitutionMailTemplate.getMailHint(MailTemplateType.ABMELDUNG_DURCH_EINRICHTUNG),
});

export async function notifyAbmeldungDurchEinrichtung(data: { participationID: string; useOldSlots?: any[] }) {
  notifyAbmeldung({ ...data, throughAdmin: true });
}
